<template>
  <v-container>
    <v-text-field
      label="Опыт практического применения (оценка эксперта)"
      v-model="chapterTwoScore"
      type="number"
      @input="$v.chapterTwoScore.$touch()"
      @blur="$v.chapterTwoScore.$touch()"
      :error-messages="chapterTwoScoreErrors"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";
import { between } from "vuelidate/lib/validators";

export default {
  name: "TheChapterTwoScore",
  components: {},
  data: () => ({}),
  validations: {
    chapterTwoScore: { between: between(0, 10) },
  },
  props: {},
  computed: {
    ...mapGetters({ card: GETTERS.CARD_DATA }),

    chapterTwoScore: {
      get() {
        return this.card.chapterTwoScore;
      },
      set(value) {
        this.modify({ chapterTwoScore: value });
      },
    },

    chapterTwoScoreErrors() {
      const errors = [];
      if (!this.$v.chapterTwoScore.between) {
        errors.push("Значение от 0 до 10!");
      }
      return errors;
    },
    invalid() {
      return this.$v.$invalid;
    },
  },
  methods: {
    ...mapMutations({
      modify: MUTATIONS.MODIFY_CARD_DATA,
    }),
  },
  watch: {
    invalid(value) {
      this.$emit("change-invalid", value);
    },
  },
};
</script>
